var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('img',{staticClass:"bg-black",staticStyle:{"object-fit":"cover","object-position":"0 0"},attrs:{"src":("data:image/png;base64," + _vm.image)},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }